// User helper utilities for localStorage-based user management
import { jwtDecode } from 'jwt-decode';

export const getUserId = () => {
  try {
    const token = localStorage.getItem('tellmiz_access_token');
    if (token) {
      const decoded = jwtDecode(token);
      return decoded.id || decoded._id || decoded.userId || null;
    }
  } catch (error) {
    console.error('Error getting user ID:', error);
  }
  return null;
};

export const getUser = () => {
  try {
    const token = localStorage.getItem('tellmiz_access_token');
    if (token) {
      const decoded = jwtDecode(token);
      return decoded;
    }
  } catch (error) {
    console.error('Error getting user:', error);
  }
  return null;
};

export const getUnreadMessagesCount = () => {
  // This would normally fetch from an API or store
  // For now, return 0 as placeholder
  return 0;
};

export const isAuthenticated = () => {
  const token = localStorage.getItem('tellmiz_access_token');
  return !!token;
};

